<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{ 'KPIS_TECHNICIEN.TITRE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" color="white" icon-only (click)="closeModal()">
        <ion-icon color="light" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="content">
  <div class="semaine">{{ ('KPIS_TECHNICIEN.SEMAINE' | translate) + ' ' + kpis.numeroSemaine }}</div>

  <kpi-technicien
    [titre]="'KPIS_TECHNICIEN.KPI_SAISIE_FIL_EAU.TITRE' | translate"
    [description]="'KPIS_TECHNICIEN.KPI_SAISIE_FIL_EAU.DESCRIPTION' | translate"
    [kpi]="kpis.saisieFilEau"
    [objectif]="objectifFilEau"
  ></kpi-technicien>

  <kpi-technicien
    [titre]="'KPIS_TECHNICIEN.KPI_TAUX_OT_PLANIFES_REALISES.TITRE' | translate"
    [description]="'KPIS_TECHNICIEN.KPI_TAUX_OT_PLANIFES_REALISES.DESCRIPTION' | translate"
    [kpi]="kpis.tauxOtPlanifiesRealises"
    [objectif]="objectifRealisation"
  ></kpi-technicien>

  <kpi-technicien
    [titre]="'KPIS_TECHNICIEN.KPI_TAUX_REMPLISSAGE_AGENDA.TITRE' | translate"
    [description]="'KPIS_TECHNICIEN.KPI_TAUX_REMPLISSAGE_AGENDA.DESCRIPTION' | translate"
    [kpi]="kpis.tauxRemplissageAgenda"
    [objectif]="objectifAgenda"
  ></kpi-technicien>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button expand="block" (click)="closeModal()" color="danger">{{ 'GLOBAL.OK' | translate }}</ion-button>
  </ion-toolbar>
</ion-footer>
